import React, { Component } from 'react';
import OktaAuth from '@okta/okta-auth-js';
import { withAuth } from '@okta/okta-react';
import config from '../config/okta.config';
import { Form, FormGroup, Label, Input, FormFeedback, FormText } from 'reactstrap';
import { ThemeConsumer } from 'styled-components';

export default withAuth(class LoginForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sessionToken: null,
      username: '',
      password: '',
      buttonText: 'Login',
      spinnerDisplay: 'none'
    }
  
    this.oktaAuth = new OktaAuth({ url: config[window.location.hostname].issuer });

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
  }

  handleSubmit(e) {
    this.setState({buttonText:"Login ...",
    spinnerDisplay: 'block'});
    e.preventDefault();
    this.oktaAuth.signIn({
      username: this.state.username,
      password: this.state.password
    })
    .then(res => this.setState({
      sessionToken: res.sessionToken,
      buttonText: 'Login'
    }))
    .catch(err => {
      document.getElementById('invalidPassword').style.display ='inline';
      // this.state.buttonText = "Login ...";
      // this.state.buttonText = "Login";
      // this.state.spinnerDisplay = 'none';
      console.log('Found an error', err);
        }
      );
  }

  handleUsernameChange(e) {
    this.setState({username: e.target.value});
  }

  handlePasswordChange(e) {
    this.setState({password: e.target.value});
  }

  render() {
    if (this.state.sessionToken) {
      this.props.auth.redirect({sessionToken: this.state.sessionToken});
      return null;
    }

    return (

      <div className="app-container app-theme-white body-tabs-shadow">
          <div className="app-container">
              <div className="h-100">
              <div className="h-100 no-gutters row">
              <div className="d-none d-lg-block col-lg-4">
              <div className="slider-light">
              <div className="slick-slide slick-current slick-active" data-slick-index="0" aria-hidden="false" role="tabpanel" id="slick-slide00" aria-describedby="slick-slide-control00" style={{width: "640px"}}><div><div style={{"width": "100%",display: "inline-block"}}>
                                  <div className="position-relative h-100 d-flex justify-content-center align-items-center" tabIndex="-1">
                                      <div >
                                          <img src="davinci-xi-surgical-system.png"/>
                                      </div>
                                      <div className="slider-content"><h3></h3>
                                          <p></p></div>
                                  </div>
                              </div></div></div>
                              </div>
                              </div>

                      <div className="h-100 d-flex bg-white justify-content-center align-items-center col-md-12 col-lg-8">
                          <div className="mx-auto app-login-box col-sm-12 col-md-10 col-lg-9">
                              <div className="app-logo">Quality 360</div>
                              <h4 className="mb-0">
                                  <span className="d-block">Welcome back,</span>
                                  <span>Please sign in to your account.</span></h4>

                              <div className="divider row"></div>
                              <div>
                                  <form className=""  onSubmit={this.handleSubmit}>
                                      <div className="form-row">
                                          <div className="col-md-6">
                                              <div className="position-relative form-group"><label  className="">User Name</label><input id="username" type="text"  value={this.state.username} onChange={this.handleUsernameChange} placeholder="User Name here..."  className="form-control"/></div>
                                          </div>
                                          <div className="col-md-6">
                                              <div className="position-relative form-group"><label  className="">Password</label><input id="password" type="password"    value={this.state.password} onChange={this.handlePasswordChange}  placeholder="Password here..." className="form-control"/></div>
                                          </div>
                                      </div>
                                      {/* <div className="position-relative form-check"><input name="check" id="exampleCheck" type="checkbox" className="form-check-input"/><label for="exampleCheck" className="form-check-label">Keep me logged in</label></div> */}
                                      <div>
                                      <FormFeedback id='invalidPassword' style={{fontWeight:'bold',fontSize:'1rem'}}>Invalid UserID/Password</FormFeedback>
                                      </div>
                                      <div className="d-flex align-items-center">
                                          <div className="ml-auto">
                                              <button type="submit" className="btn btn-primary">
                                             <span style={{float:'left',display:this.state.spinnerDisplay,marginRight: '3px'}} className="spinner-border spinner-border-sm" ></span>
                                             <div style={{float:'right'}}>{this.state.buttonText} </div> </button>
                                          </div>
                                      </div>
                                  </form>
                                </div>
                            </div>
                        </div>
                          </div>
                    </div>
                </div>
          </div>




    );
  }
});